<script lang="ts">
    export let image : string
    export let title : string = "Fullstack developer"
    export let secondaryCopy : string
    export let locations : string

    let locationsText = ''

    const checkRemoteText = (text: string) => {
            if(text === 'Remote') return 'remotely'
            return text
    }

    const formatText = (locations) => {

         if(locations[0].cities.length > 1) {
            locationsText = `in ${checkRemoteText(locations[0].cities[0])} and ${checkRemoteText(locations[0].cities[1])}`
         }else{
            locationsText = locations[0].cities[0] !== 'Remote' ? `in ${checkRemoteText(locations[0].cities[0])}` : `${checkRemoteText(locations[0].cities[0])}`
         }

         return locationsText
    }
</script>


<div class="candidate-info">
    <span class="candidate-info__title"><img src={image} alt="anonymous candidate profile picture"/> <h3>{title}</h3></span>
    <p class="candidate-info__sub">{secondaryCopy}</p>
    <p class="candidate-info__sub">
        Wants to work {formatText(locations)}
    </p>
</div>

<style lang="postcss">

    .candidate-info {
        color: var(--color_offerzen_black);

        & .candidate-info__title {
            display: flex;
            align-items: center;
            gap:12px;
            margin:0 0 12px;

            & img {
                border-radius: 90px;
                height:70px;
            }

            & h3 { 
                margin:0;
            }
        }

        & .candidate-info__sub {
            font-size:16px;
            line-height:1.2;
            margin:0;
        }
    }
</style>